<template>
  <div class="newsDetail">
    <h1>最新消息</h1>
    <div class="newsDetail__container">
      <div class="newsDetail__header">
        <div class="newsDetail__title">{{thisNews.title}}</div>
        <div class="newsDetail__date">{{thisNews.date}}</div>
      </div>
      <div class="newsDetail__body">
        <div class="newsDetail__description" v-html="thisNews.description"></div>
        <div class="newsDetail__banner">
          <img :src="thisNews.banner" alt="">
        </div>
        <div class="newsDetail__content" v-html="thisNews.content"></div>
      </div>
      <div class="newsDetail__funcBtns">
        <div class="newer">
          <a href="#" @click='go_page(newerNewsRoute)'
          v-if="!is_firstNews" title="新一則">
            <img src="@/assets/icon/page_num_nav_arrow_left.png" alt="">
          </a>
        </div>
        <div class="back">
          <a href="#" @click="go_page('/front/news')">BACK</a>
        </div>
        <div class="older">
          <a href="#" @click='go_page(olderNewsRoute)'
          v-if="!is_lastNews" title="舊一則">
            <img src="@/assets/icon/page_num_nav_arrow_right.png" alt="">
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    news() {
      let news;
      this.$bus.$on('son_get_data', (data) => {
        news = data.news;
      });
      this.$bus.$emit('son_call_data');
      return news;
    },
    thisNews() {
      return this.news.find((item) => item.id === this.$route.params.id);
    },
    is_firstNews() {
      return this.news.findIndex((item) => item.id === this.thisNews.id) === 0;
    },
    is_lastNews() {
      return this.news.findIndex((item) => item.id === this.thisNews.id) === this.news.length - 1;
    },
    newerNewsRoute() {
      let str = '';
      if (!this.is_firstNews) {
        const newerId = this.news[this.news.findIndex((item) => item === this.thisNews) - 1].id;
        str = `/front/news/${newerId}`;
      }
      return str;
    },
    olderNewsRoute() {
      let str = '';
      if (!this.is_lastNews) {
        const olderId = this.news[this.news.findIndex((item) => item === this.thisNews) + 1].id;
        str = `/front/news/${olderId}`;
      }
      return str;
    },
  },
  methods: {
    go_page(route) {
      this.$router.push(route);
    },
  },
};
</script>
